/**
 * Fixed full-screen overlay that adds a subtle paper-grain texture on top
 * of every page. Replaces the old CRT `<Scanlines />` overlay.
 *
 * The actual grain is a tiled SVG fractalNoise data-URI applied via the
 * `.paper-grain` class in `src/styles/index.css`. Kept in JSX as a separate
 * component so reduced-motion / accessibility tweaks live in one place.
 */
const PaperGrain = () => (
  <div aria-hidden className="paper-grain pointer-events-none fixed inset-0 z-50" />
);

export default PaperGrain;
